import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { FieldArray, Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import { nurseryBatchInfo } from "../../../SchemaInfo/info";
import { nurseryBatchSchema } from "../../../Schemas/Farm support/nursery_management_schema";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { FcStackOfPhotos } from "react-icons/fc";
import { FaLeaf } from "react-icons/fa6";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";

const getSchedule = (day) => {
  if (day === 1) {
    return "";
  }
  if (day === 2) {
    return "Cover seed packets";
  }
  if (day === 3) {
    return "Keep covered";
  }
  if (day === 4) {
    return "";
  }
  if (day === 5) {
    return "check for sprouting";
  }
  if (day === 6) {
    return "Spread the trays";
  }
  if (day === 7) {
    return "Calculate germination rate and add new seeds if needed.";
  }
  if (day === 16) {
    return "Watering + neem oil sprey (1ml/ltr)";
  }
  if (day === 25) {
    return "Watering + chelated ferrous (1gm/ltr)";
  }
  if (day === 28) {
    return "Watering + fertilizers 19:19:19 (1.5gm/ltr)";
  }
  if (day === 16) {
    return "Watering + neem oil sprey (1ml/ltr)";
  } else {
    if (day % 3 === 1 && day > 7) {
      return "Watering + fertilizers 19:19:19 (1gm/ltr)";
    } else {
      return "Watering";
    }
  }
};

const getActions = (day) => {
  if (day === 1) {
    return "Wash trays with H2O2 or 5ml phDown in 10ltr water.";
  }
  if (day === 15) {
    return "Check plant have 2 leaves. If not connect with agronomist.";
  }
  if (day === 21) {
    return "Below tray see if you can see the roots of plants.";
  }
  if (day === 29) {
    return "Try to pull the plant by holding at stem.";
  }
  if (day === 30) {
    return "Plant are ready to transfer in the system.";
  } else {
    return "";
  }
};

const generateDateLabels = (startdate) => {
  const schedule = [];
  for (let i = 0; i < 30; i++) {
    const date = new Date(startdate);
    date.setDate(date.getDate() + i);

    schedule.push({
      date: date.toISOString().split("T")[0],
      schedule: getSchedule(i + 1),
      actions: getActions(i + 1),
      scheduleDone: false,
      scheduleDoneDate: "",
    });
  }

  return schedule;
};

const getScheduleBadge = (schedule) => {
  if (schedule === "Watering") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>{" "}
      </p>
    );
  }
  if (schedule === "Watering + fertilizers 19:19:19 (1gm/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-orange text-white m-1">
          Fertilizers NPK(19-19-19) (1gm/ltr)
        </span>
      </p>
    );
  }
  if (schedule === "Watering + fertilizers 19:19:19 (1.5gm/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-orange text-white m-1">
          Fertilizers NPK(19-19-19) (1.5gm/ltr)
        </span>
      </p>
    );
  }
  if (schedule === "Watering + neem oil sprey (1ml/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-purple text-white m-1">
          Neem oil sprey (3000PPM) (1ml/ltr)
        </span>
      </p>
    );
  }
  if (schedule === "Watering + chelated ferrous (1gm/ltr)") {
    return (
      <p className="m-0 p-0">
        <span className="badge bg-azure text-white m-1">Watering</span>
        <span className="badge bg-purple text-white m-1">
          Chelated ferrous (1ml/ltr)
        </span>
      </p>
    );
  } else {
    return schedule;
  }
};

const AddBatch = () => {
  const store = useSelector((store) => store.login.user);
  const [batchNameError, setBatchNameError] = useState("");
  const navigate = useNavigate();
  const [plantList, setPlantList] = useState();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isHandOverCompleted, setIsHandOverCompleted] = useState(false);

  useEffect(() => {
    performRequest("GET", "/handOver/getHandOver/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.handOverData?.length > 0) {
            setIsHandOverCompleted(true);
          } else {
            setIsHandOverCompleted(false);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/nurseryManagement/getNurseryManagement", 1, 50)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Attendance!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/agronomyWiki/getAllAgronomyWiki/")
      .then((res) => {
        if (res.status === 200) {
          setPlantList(res?.data?.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, []);
  // const handelSubmit = (values) => {
  //   const date = new Date(values.batchStartDate);
  //   date.setDate(date.getDate() + 29);

  //   values = {
  //     ...values,
  //     genratedBy: store.UserId,
  //     cropName: +values.cropName,
  //     batchEndDate: date.toISOString().split("T")[0],
  //   };
  //   let formData = new FormData();
  //   for (let key in values) {
  //     formData.append(key, values[key]);
  //   }
  //   const headers = { "Content-Type": "multipart/form-data" };
  //   performRequest(
  //     "POST",
  //     "/nurseryManagement/createNurseryManagement",
  //     formData,
  //     headers
  //   )
  //     .then((res) => {
  //       if (res.status === 201) {
  //         Toast("success", "New batch created successfully!");
  //         navigate(`/farm-nursery-management/`);
  //       } else {
  //         Toast("error", "Error while creating Batch!");
  //       }
  //     })
  //     .catch((err) => {
  //       // Toast("error", "Server Error");
  //       // console.error("Error", err);
  //       CustomErrorResponse(err);
  //     });
  //   // .finally(() => setLoading(false));
  // };
  const handelSubmit = (values) => {
    const date = new Date(values.batchStartDate);
    date.setDate(date.getDate() + 29);

    let finalValues = {
      ...values,
      genratedBy: store.UserId,
      cropName: +values.cropName,
      batchEndDate: date.toISOString().split("T")[0],
    };

    let formData = new FormData();

    Object.keys(finalValues).forEach((key) => {
      const value = finalValues[key];

      // CASE 1: File (image)
      if (value instanceof File) {
        formData.append(key, value);
      }

      // CASE 2: Array or Object → convert to JSON
      else if (Array.isArray(value) || typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      }

      // CASE 3: Normal field
      else {
        formData.append(key, value);
      }
    });

    setLoading(true);
    performRequest(
      "POST",
      "/nurseryManagement/createNurseryManagement",
      formData,
      { "Content-Type": "multipart/form-data" }
    )
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "New batch created successfully!");
          navigate(`/farm-nursery-management/`);
        } else {
          Toast("error", "Error while creating Batch!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const searchUnique = (value, store) => {
    performRequest(
      "GET",
      `/nurseryManagement/getUniqueBatchName?batchName=${value}&genratedBy=${store.UserId}`
    ).then((res) => {
      if (
        res?.data === "Batch name already in use, please use some unique name."
      ) {
        setBatchNameError(res.data);
      } else {
        setBatchNameError("");
      }
    });
  };
  let searchTimer;
  function startSearch(value, store) {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      searchUnique(value, store);
    }, 1000);
  }


    if (loading) {
      return <LoadingPage />;
    }

  if (!isHandOverCompleted && data?.nurseryManagementCount >= 1) {
    navigate("/farm-nursery-management/");
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcStackOfPhotos className="fs-2  me-1" />
                  Nursery Management
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Create a new batch of nursery.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a
                    href={"/farm-nursery-management/"}
                    className="btn btn-primary"
                  >
                    {" "}
                    <FaLeaf className="fs-3 me-2" /> ALL BATCHES
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <h2>Precautions for nursery:</h2>
                <ol>
                  <li>Always use new low ec or buffered cocopeat.</li>
                  <li>
                    ⁠Use new seeds and read truthful label for expiry of seeds.
                  </li>
                  <li>
                    ⁠Wash trays thoroughly with hydrogen paraoxide for higher
                    germination.
                  </li>
                  <li>
                    Always plant 10% extra seeds then your required plant count.
                  </li>
                  <li>Do not miss your schedule.</li>
                  <li>⁠Take actions as suggested.</li>
                  <li>
                    If you are stuck with progress or results, contact your
                    agronomist or relation manager.{" "}
                  </li>
                </ol>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={nurseryBatchInfo}
                  validationSchema={nurseryBatchSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="row">
                          <div className="">
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Batch name
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="batchName"
                                  onChange={(e) => {
                                    props.setFieldValue(
                                      "batchName",
                                      e.target.value
                                    );
                                    startSearch(e.target.value, store);
                                  }}
                                />
                                {batchNameError && (
                                  <p className="text-danger">
                                    {batchNameError}
                                  </p>
                                )}
                                {props.touched.batchName &&
                                  props.errors.batchName && (
                                    <p className="text-danger">
                                      {props.errors.batchName}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Crop name
                              </label>
                              <div className="w-100 col">
                                <CustomSelect type="text" name="cropName">
                                  <option value="">Select</option>
                                  {plantList &&
                                    plantList?.map((plant) => {
                                      return (
                                        <option key={plant.id} value={plant.id}>
                                          {plant.name}
                                        </option>
                                      );
                                    })}
                                </CustomSelect>

                                {props.touched.cropName &&
                                  props.errors.cropName && (
                                    <p className="text-danger">
                                      {props.errors.cropName}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Number of plants
                              </label>
                              <div className="w-100 col">
                                <CustomInput name="numberOfplants" />

                                {props.touched.numberOfplants &&
                                  props.errors.numberOfplants && (
                                    <p className="text-danger">
                                      {props.errors.numberOfplants}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Batch start date
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="batchStartDate"
                                  type={"date"}
                                  onChange={(e) => {
                                    props.setFieldValue(
                                      "batchStartDate",
                                      e.target.value
                                    );
                                    props.setFieldValue(
                                      "schedule",
                                      generateDateLabels(e.target.value)
                                    );
                                  }}
                                />

                                {props.touched.batchStartDate &&
                                  props.errors.batchStartDate && (
                                    <p className="text-danger">
                                      {props.errors.batchStartDate}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Crop packet front image
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="cropPackFront"
                                  type="file"
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "cropPackFront",
                                      e.target.files[0]
                                    )
                                  }
                                />
                                {props.touched.cropPackFront &&
                                  props.errors.cropPackFront && (
                                    <p className="text-danger">
                                      {props.errors.cropPackFront}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Crop packet back image
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="cropPackBack"
                                  type="file"
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "cropPackBack",
                                      e.target.files[0]
                                    )
                                  }
                                />
                                {props.touched.cropPackBack &&
                                  props.errors.cropPackBack && (
                                    <p className="text-danger">
                                      {props.errors.cropPackBack}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {props.values.batchName &&
                          props.values.cropName &&
                          props.values.numberOfplants &&
                          props.values.batchStartDate && (
                            <div className="card table-responsive">
                              <FieldArray name="schedule">
                                {({ push, remove }) => (
                                  <table className="table table-vcenter">
                                    <thead>
                                      <tr>
                                        <th>Day</th>
                                        <th>schedule on</th>
                                        <th>Schedule work</th>
                                        {/* <th>Actions</th> */}
                                        <th>Mark work done</th>
                                        <th>Work done date</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {props.values?.schedule?.map(
                                        (schedule, index) => {
                                          return (
                                            <tr key={index}>
                                              <td>{index + 1}</td>
                                              <td>{schedule.date}</td>
                                              <td>
                                                {schedule.schedule
                                                  ? getScheduleBadge(
                                                      schedule.schedule
                                                    )
                                                  : "---"}
                                                {schedule.actions || ""}
                                              </td>
                                              <td>
                                                <CustomCheckbox
                                                  type="checkbox"
                                                  width={"25px"}
                                                  height={"25px"}
                                                  name={`schedule[${index}].scheduleDone`}
                                                  onChange={(e) => {
                                                    props.setFieldValue(
                                                      `schedule[${index}].scheduleDone`,
                                                      !schedule.scheduleDone
                                                    );
                                                    let date = new Date();
                                                    props.setFieldValue(
                                                      `schedule[${index}].scheduleDoneDate`,
                                                      !schedule.scheduleDone
                                                        ? date
                                                            .toISOString()
                                                            .split("T")[0]
                                                        : ""
                                                    );
                                                  }}
                                                ></CustomCheckbox>
                                              </td>
                                              <td>
                                                {schedule.scheduleDoneDate ||
                                                  "---"}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                )}
                              </FieldArray>
                            </div>
                          )}
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton
                            buttonText="Create Batch"
                            disabled={batchNameError}
                          />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default AddBatch;
